<section class="waiting-verification-section">
    <ng-container *ngIf="isPage || !hasRedirect">
        <div class="waiting-verification-page-title-wrapper">
            <p class="waiting-verification-page-title">
                {{ "pt.edp.edponline.waiting.verification.page.title" | translate }}
            </p>
        </div>
    </ng-container>
    <div class="text-center">
        <p class="waiting-verification-title">{{ "pt.edp.edponline.waiting.verification.title" | translate }}</p>
    </div>
    <div class="gif-wrapper">
        <ng-lottie [width]="mobileSize ? '100%' : '400px'" [height]="mobileSize ? '100%' : '400px'" [options]="options"></ng-lottie>
    </div>
</section>
